// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"9ba0469b","787":"362be87c"}[chunkId] + ".chunk.js";
};